import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  timezone: string;
};

type Response = any; // You might want to type this more specifically

const validate = (params: RequestParams) => {
  const { timezone } = params;
  if (!timezone) {
    throw new Error('Timezone is required');
  }
};

export const getActiveOrderCounts = async (
  scope: RequestScope,
  params: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(params);

    const { timezone } = params;
    const tzParam = 'tz=' + timezone;
    const url = `/metrics/active_unshipped_order_count_by_channel?${tzParam}`;

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(url, options);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
